import type { Plan } from '@/api/subscription-hooks'
import type { BillingInterval } from '@/lib/billing-interval'
import { annualOptionLabel } from '@/lib/plan-pricing'

/**
 * Monthly / Annual, as one control used by both the plan card and the upgrade
 * panel (CLA-1622) — the same choice, so it looks and reads the same in both.
 * The Annual option carries the saving, computed from `plans` (the ones on
 * offer where it is shown), so the cheaper option is visible before choosing.
 */
export function IntervalToggle({
  value,
  onChange,
  plans,
}: {
  value: BillingInterval
  onChange: (i: BillingInterval) => void
  plans: Plan[]
}) {
  return (
    <div className="flex rounded-lg border border-border overflow-hidden text-xs flex-shrink-0">
      {(['monthly', 'annual'] as const).map((i) => (
        <button
          key={i}
          type="button"
          aria-pressed={value === i}
          onClick={() => onChange(i)}
          className={
            value === i
              ? 'px-2.5 py-1 bg-claro-500 text-white'
              : 'px-2.5 py-1 bg-surface text-ink-secondary hover:bg-surface-secondary'
          }
        >
          {i === 'monthly' ? 'Monthly' : annualOptionLabel(plans)}
        </button>
      ))}
    </div>
  )
}
